import { createSelector } from '@reduxjs/toolkit';

// Reads `state.reAuthenticate`, now backed by the RTK `reauthenticate` slice. The key
// stays `reAuthenticate` so the untouched entry (PrivateRoute -> updateReauthenticateSessionID)
// keeps working; the slice's action creators are what those dispatchers now fire.
const selectReauthRoot = (state) => state.reAuthenticate ?? {};

export const selectReauthSessionId = createSelector(
    selectReauthRoot,
    (reauth) => reauth.reAuthenticateSessionID
);

export const selectReauthStatus = createSelector(
    selectReauthRoot,
    (reauth) => reauth.reauthenticateSessionStatus ?? {}
);

export const selectReauthTheme = createSelector(selectReauthStatus, (status) => status.theme ?? {});

export const selectSelfieVerification = createSelector(
    selectReauthStatus,
    (status) => status.selfieVerification ?? {}
);

export const selectAdditionalVerification = createSelector(
    selectReauthStatus,
    (status) => status.additionalVerification ?? {}
);

export const selectCodeResentAt = createSelector(
    selectReauthRoot,
    (reauth) => reauth.codeResentAt ?? null
);

export const selectIsDeviceInfoSent = createSelector(
    selectReauthRoot,
    (reauth) => reauth.isDeviceInfoSent
);
